export default "__VITE_ASSET__Bs7qIFTe__"